/**
 * "Continue with LinkedIn", then Google / Microsoft / Apple — the top of the
 * first step of /login and /signup, and the "or with email" line under it.
 * Renders `useSocialSignInPanel`: only the providers the Clerk instance
 * offers; with none, no buttons and no divider — the email form stands alone.
 */
import { AlertCircle } from '@tonnie/assets';
import { useSocialProviderLabels, useTranslation } from '@tonnie/locale';
import { Alert, AlertDescription, AuthDivider, SocialSignInButtons } from '@tonnie/ui';

import { useSocialSignInPanel } from './use-social-sign-in-panel';

export function SocialSignInSection({ mode }: { mode: 'sign-in' | 'sign-up' }) {
  const { t } = useTranslation();
  const labels = useSocialProviderLabels();
  const { providers, ready, pending, error, select } = useSocialSignInPanel(mode);

  if (providers.length === 0 && !error) return null;

  return (
    <>
      <div className="space-y-4">
        {error && (
          <Alert variant="destructive" data-testid="auth-social-error">
            <AlertCircle className="h-4 w-4" aria-hidden="true" />
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        )}
        {providers.length > 0 && (
          <SocialSignInButtons
            providers={providers}
            labels={labels}
            onSelect={select}
            pending={pending}
            disabled={!ready}
            testIdPrefix={mode === 'sign-in' ? 'auth-login-oauth' : 'auth-signup-oauth'}
          />
        )}
      </div>
      {providers.length > 0 && <AuthDivider label={t('auth.flow.orWithEmail')} />}
    </>
  );
}
